Shopify.queryParams = {}
if (location.search.length) {
  for (let aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
    aKeyValue = aCouples[i].split('=')
    if (aKeyValue.length > 1) {
      Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1])
    }
  }
}

Shopify.buildQuery = function () {
  const query = []
  for (const key in this.queryParams) {
    if (this.queryParams.hasOwnProperty(key)) {
      query.push(key + '=' + encodeURIComponent(this.queryParams[key]))
    }
  }
  return query.join('&')
}

function initCollectionSubtitle() {
  const titleLanding = document.querySelectorAll('.js-collection-title-landing')
  if (!titleLanding.length) return
  const colDesc = document.querySelector('.js-collection-description')
  if (!colDesc) return titleLanding.forEach(item => item.removeAttribute('hidden'))
  const title = colDesc.querySelector('h1,h2,h3,h4,h5,h6')
  if (!title) return titleLanding.forEach(item => item.removeAttribute('hidden'))
  
  for (const item of titleLanding) {
    item.innerHTML = title.innerHTML
    item.removeAttribute('hidden')
  }
  title.remove()
}
initCollectionSubtitle()

function isEmptyObject(obj) {
  for (const key in obj) {
    return false
  }
  return true
}

function initCollectionTagsFilter() {
  const tag = document.querySelector('.js-collection-tags-filter')
  if (!tag) return

  tag.addEventListener('change', () => {
    delete Shopify.queryParams.page

    if (isEmptyObject(Shopify.queryParams)) {
      location.href = tag.value
    } else {
      location.href = `${tag.value}?${Object.keys(Shopify.queryParams).map(key => `${key}=${encodeURIComponent(Shopify.queryParams[key])}`).join('&')}`
    }
  })
}
initCollectionTagsFilter()

function iniCollectionSort() {
  const sort = document.querySelector('.js-collection-sort')
  if (!sort) return

  sort.addEventListener('change', () => {
    Shopify.queryParams.sort_by = sort.value
    location.search = decodeURIComponent(Shopify.buildQuery())
  })
}
iniCollectionSort()
